export default {"src":"/_next/static/media/c_Platinum_0.2c1c5f95.svg","height":92,"width":88,"blurWidth":0,"blurHeight":0};